import { IconArrowLeft, IconArrowRight } from "@tabler/icons-react";
import { Button, Group } from "@/components/ui";

interface Props {
  todosAsignados: boolean;
  faltantes: number;
  soloLectura: boolean;
  onVolver: () => void;
  onContinuar: () => void;
}

/**
 * Botonera inferior · "Regresar a Datos generales" (step anterior del wizard)
 * a la izquierda, "Continuar al prorrateo" a la derecha si no estamos en
 * solo lectura (deshabilitado mientras falten asignaciones).
 */
export function ProveedorActions({ todosAsignados, faltantes, soloLectura, onVolver, onContinuar }: Props) {
  return (
    <Group justify="space-between" className="mt-1">
      <Button leftSection={<IconArrowLeft size={14} />} onClick={onVolver}>
        Regresar a Datos generales
      </Button>
      {!soloLectura && (
        <Button rightSection={<IconArrowRight size={14} />} disabled={!todosAsignados} onClick={onContinuar}>
          {todosAsignados ? "Continuar al prorrateo" : `Asigna proveedor a ${faltantes} RFC restantes`}
        </Button>
      )}
    </Group>
  );
}
